<template>
  <Dialog 
    title="Clone Campaign"
    :customClose="close"
    :disableButtons="showSpinner"
    @submit="cloneCampaign"
  >
    <div v-if="showSpinner" class="spinner-wrap">
      <spinner />
    </div>
    <form v-else @submit.prevent="cloneCampaign">
      <div class="form-group">
        <label for="campaign-name">Campaign Name*</label>
        <input id="campaign-name"
           class="form-control"
           type="text"
           name="campaignName"
           :class="{'is-invalid': errors.has('campaignName')}"
           v-model.trim="campaignName"
           v-validate="'required'"
           placeholder="Name"
         />
        <small v-show="errorMessage.campaignName" class="invalid-feedback">
          {{errorMessage.campaignName}}
        </small>
      </div>
    </form>
  </Dialog>
</template>
<script>
import Dialog from '@/components/Dialog';
import Spinner from '@/components/Spinner';
import ModalMixin from '@/mixins/ModalMixin';
import CLONE_CAMPAIGN from '@/graphql/Campaigns/CloneCampaign.gql';
import { mapActions } from 'vuex';

export default {
  mixins: [ModalMixin],
  components: { Dialog, Spinner },
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    campaignName: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      errorMessage: {},
      showSpinner: false,
    };
  },
  methods: {
    ...mapActions(['trackEvent']),
    close() {
      this.$router.go(-1);
    },
    async cloneCampaign() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }
      this.showSpinner = true;
      const result = await this.$apollo.mutate({
        mutation: CLONE_CAMPAIGN,
        variables: {
          name: this.campaignName,
          id: this.campaignId,
        },
      });
      this.trackEvent({
        name: "Campaign Cloned",
        options: {
          "campaign_name": this.campaignName,
          "campaign_uid": result.data.cloneCampaign.id
        }
      });
      this.$router.push({ name: 'CampaignDetails', params: { id: result.data.cloneCampaign.id } });
      this.$notify({
        group: 'success',
        type: 'success',
        text: 'Campaign was cloned',
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/modals/CloneCampaignModal.vue